var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4858 7.57765L23.4977 3.70871C28.6038 2.29882 32.3026 4.59885 33.7248 10.0682L37.6236 25.0627C39.0458 30.5321 36.9585 34.4297 31.8524 35.8396L17.8405 39.7085C12.7344 41.1184 9.04894 38.8147 7.62678 33.3453L3.7279 18.3509C2.30574 12.8815 4.37967 8.98754 9.4858 7.57765Z",
    fill: "#E1EBF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9773_68922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.103 12.2053L22.6159 9.57863C26.0825 8.62143 28.5664 10.0779 29.4837 13.6057L31.9985 23.2774C32.9158 26.8052 31.4714 29.3463 28.0048 30.3035L18.4919 32.9302C15.0253 33.8874 12.5505 32.4285 11.6332 28.9006L9.11833 19.229C8.20102 15.7011 9.63636 13.1625 13.103 12.2053Z",
    fill: "url(#paint0_linear_9773_68922)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_9773_68922)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_9773_68922",
    maskUnits: "userSpaceOnUse",
    x: 10.7448,
    y: 9.68506,
    width: 37,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.7448,
    y: 9.68506,
    width: 37,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 10.6851H21.007C15.0812 10.6851 11.7448 14.1233 11.7448 20.2297V36.9552C11.7448 43.0258 15.0812 46.4998 21.007 46.4998H37.2377C43.1461 46.4998 46.4999 43.0258 46.4999 36.9552V20.2297C46.4999 14.1233 43.1287 10.6851 37.2203 10.6851"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 10.6851H21.007C15.0812 10.6851 11.7448 14.1233 11.7448 20.2297V36.9552C11.7448 43.0258 15.0812 46.4998 21.007 46.4998H37.2377C43.1461 46.4998 46.4999 43.0258 46.4999 36.9552V20.2297C46.4999 14.1233 43.1287 10.6851 37.2203 10.6851",
    fill: "#D7E6F4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 11.6851C37.7726 11.6851 38.2203 11.2373 38.2203 10.6851C38.2203 10.1328 37.7726 9.68506 37.2203 9.68506V11.6851ZM37.2203 9.68506C36.668 9.68506 36.2203 10.1328 36.2203 10.6851C36.2203 11.2373 36.668 11.6851 37.2203 11.6851V9.68506ZM37.2203 9.68506H21.007V11.6851H37.2203V9.68506ZM21.007 9.68506C17.8514 9.68506 15.2473 10.6047 13.4361 12.4711C11.6292 14.333 10.7448 17.0002 10.7448 20.2297H12.7448C12.7448 17.3528 13.5286 15.2476 14.8714 13.8639C16.2099 12.4846 18.2368 11.6851 21.007 11.6851V9.68506ZM10.7448 20.2297V36.9552H12.7448V20.2297H10.7448ZM10.7448 36.9552C10.7448 40.1682 11.6299 42.834 13.4351 44.6994C15.245 46.5696 17.8486 47.4998 21.007 47.4998V45.4998C18.2397 45.4998 16.2121 44.693 14.8723 43.3086C13.5279 41.9193 12.7448 39.8128 12.7448 36.9552H10.7448ZM21.007 47.4998H37.2377V45.4998H21.007V47.4998ZM37.2377 47.4998C40.3881 47.4998 42.991 46.5693 44.8026 44.6999C46.6097 42.8351 47.4999 40.1695 47.4999 36.9552H45.4999C45.4999 39.8115 44.7132 41.9182 43.3663 43.3081C42.0239 44.6934 39.9957 45.4998 37.2377 45.4998V47.4998ZM47.4999 36.9552V20.2297H45.4999V36.9552H47.4999ZM47.4999 20.2297C47.4999 16.9975 46.6053 14.3305 44.792 12.4696C42.975 10.6049 40.3678 9.68506 37.2203 9.68506V11.6851C39.9812 11.6851 42.0138 12.4843 43.3596 13.8654C44.7089 15.2501 45.4999 17.3555 45.4999 20.2297H47.4999Z",
    fill: "url(#paint1_linear_9773_68922)",
    mask: "url(#path-3-outside-1_9773_68922)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_9773_68922)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9773_68922",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4825 30.077H30.5473V35.1448C30.5473 35.9686 29.9043 36.6311 29.1049 36.6311C28.3055 36.6311 27.6626 35.9686 27.6626 35.1448V30.077H22.7447C21.9453 30.0591 21.3024 29.3965 21.3024 28.5728C21.3024 28.1771 21.4588 27.8028 21.7194 27.5163C21.9975 27.2477 22.3624 27.0865 22.7447 27.0865H27.6626V22.0366C27.6626 21.2129 28.3055 20.5503 29.1049 20.5503C29.9043 20.5503 30.5473 21.2129 30.5473 22.0366V27.0865H35.4825C36.2819 27.0865 36.9248 27.7491 36.9248 28.5728C36.9248 29.3965 36.2819 30.0591 35.4825 30.077"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4825 30.077H30.5473V35.1448C30.5473 35.9686 29.9043 36.6311 29.1049 36.6311C28.3055 36.6311 27.6626 35.9686 27.6626 35.1448V30.077H22.7447C21.9453 30.0591 21.3024 29.3965 21.3024 28.5728C21.3024 28.1771 21.4588 27.8028 21.7194 27.5163C21.9975 27.2477 22.3624 27.0865 22.7447 27.0865H27.6626V22.0366C27.6626 21.2129 28.3055 20.5503 29.1049 20.5503C29.9043 20.5503 30.5473 21.2129 30.5473 22.0366V27.0865H35.4825C36.2819 27.0865 36.9248 27.7491 36.9248 28.5728C36.9248 29.3965 36.2819 30.0591 35.4825 30.077",
    fill: "url(#paint2_linear_9773_68922)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5473 30.077V29.877H30.3473V30.077H30.5473ZM27.6626 30.077H27.8626V29.877H27.6626V30.077ZM22.7447 30.077L22.7402 30.277H22.7447V30.077ZM21.7194 27.5163L21.5802 27.3721L21.5715 27.3817L21.7194 27.5163ZM27.6626 27.0865V27.2865H27.8626V27.0865H27.6626ZM30.5473 27.0865H30.3473V27.2865H30.5473V27.0865ZM35.4825 29.877H30.5473V30.277H35.4825V29.877ZM30.3473 30.077V35.1448H30.7473V30.077H30.3473ZM30.3473 35.1448C30.3473 35.8638 29.7882 36.4311 29.1049 36.4311V36.8311C30.0204 36.8311 30.7473 36.0733 30.7473 35.1448H30.3473ZM29.1049 36.4311C28.4216 36.4311 27.8626 35.8638 27.8626 35.1448H27.4626C27.4626 36.0733 28.1895 36.8311 29.1049 36.8311V36.4311ZM27.8626 35.1448V30.077H27.4626V35.1448H27.8626ZM27.6626 29.877H22.7447V30.277H27.6626V29.877ZM22.7492 29.8771C22.0615 29.8617 21.5024 29.2908 21.5024 28.5728H21.1024C21.1024 29.5023 21.8292 30.2566 22.7402 30.277L22.7492 29.8771ZM21.5024 28.5728C21.5024 28.2302 21.6378 27.9032 21.8674 27.6509L21.5715 27.3817C21.2797 27.7024 21.1024 28.1239 21.1024 28.5728H21.5024ZM21.8584 27.6601C22.1029 27.4239 22.4193 27.2865 22.7447 27.2865V26.8865C22.3055 26.8865 21.892 27.0714 21.5805 27.3724L21.8584 27.6601ZM22.7447 27.2865H27.6626V26.8865H22.7447V27.2865ZM27.8626 27.0865V22.0366H27.4626V27.0865H27.8626ZM27.8626 22.0366C27.8626 21.3176 28.4216 20.7503 29.1049 20.7503V20.3503C28.1895 20.3503 27.4626 21.1081 27.4626 22.0366H27.8626ZM29.1049 20.7503C29.7882 20.7503 30.3473 21.3176 30.3473 22.0366H30.7473C30.7473 21.1081 30.0204 20.3503 29.1049 20.3503V20.7503ZM30.3473 22.0366V27.0865H30.7473V22.0366H30.3473ZM30.5473 27.2865H35.4825V26.8865H30.5473V27.2865ZM35.4825 27.2865C36.1658 27.2865 36.7248 27.8538 36.7248 28.5728H37.1248C37.1248 27.6443 36.3979 26.8865 35.4825 26.8865V27.2865ZM36.7248 28.5728C36.7248 29.2908 36.1657 29.8617 35.478 29.8771L35.487 30.277C36.398 30.2566 37.1248 29.5023 37.1248 28.5728H36.7248Z",
    fill: "url(#paint3_linear_9773_68922)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_9773_68922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9773_68922",
    x: -7.15234,
    y: -6.70898,
    width: 55.4207,
    height: 55.9263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_9773_68922"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_9773_68922",
    x: -13.2552,
    y: -14.3149,
    width: 84.7552,
    height: 85.8149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9773_68922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_9773_68922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_9773_68922",
    x: 6.30237,
    y: 5.55029,
    width: 45.6224,
    height: 46.0811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_9773_68922"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.44875 0 0 0 0 0.70375 0 0 0 0 0.95125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_9773_68922",
    result: "effect2_dropShadow_9773_68922"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9773_68922",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9773_68922",
    x1: 17.864,
    y1: 10.8907,
    x2: 23.5629,
    y2: 31.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0161B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9773_68922",
    x1: 17.2772,
    y1: 14.8575,
    x2: 40.2583,
    y2: 42.4781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9773_68922",
    x1: 35.8172,
    y1: 23.4542,
    x2: 18.4142,
    y2: 24.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9773_68922",
    x1: 22.9852,
    y1: 25.9446,
    x2: 36.2509,
    y2: 26.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.93f3712f68273469d869287ae479cce6.svg";
export { ForwardRef as ReactComponent };